import { PlanFeature as BasePlanFeature, PlanTierOption } from "@/types/subscription";

// Extending the PlanFeature type to include the value property
export interface PlanFeature extends BasePlanFeature {
  value?: boolean;
}

export const PRO_TIER: PlanTierOption = {
  tier: "pro",
  label: "Pro",
  price: 12.90,
  priceId: "price_1TFC1bKk4EEvIOQPpQxvIV1h",
  maxStudents: 9999 // Unlimited
};

export const PREMIUM_TIER: PlanTierOption = {
  tier: "premium",
  label: "Premium",
  price: 19.90,
  priceId: "price_1TFC1kKk4EEvIOQPuoRXi3mv",
  maxStudents: 9999 // Unlimited
};

export const TEAMS_TIER: PlanTierOption = {
  tier: "teams",
  label: "Teams",
  price: 0, // Price to be determined
  priceId: "",
  maxStudents: 9999 // Unlimited
};

export const PRO_TIERS: PlanTierOption[] = [
  PRO_TIER
];

export const PREMIUM_TIERS: PlanTierOption[] = [
  PREMIUM_TIER
];

// Define PRICE_IDS export that was missing
export const PRICE_IDS = {
  PRO: "price_1TFC1bKk4EEvIOQPpQxvIV1h",
  PREMIUM: "price_1TFC1kKk4EEvIOQPuoRXi3mv",
  TEAMS: TEAMS_TIER.priceId
};

export const PRO_FEATURES: PlanFeature[] = [
  { text: "subscription.planFeatures.unlimitedStudents", value: true },
  { text: "subscription.planFeatures.unlimitedWorkouts", value: true },
  { text: "subscription.planFeatures.exerciseLibrary", value: true },
  { text: "subscription.planFeatures.customExercises", value: true },
  { text: "subscription.planFeatures.progressTracking", value: true },
  { text: "subscription.planFeatures.studentPortal", value: true },
  { text: "subscription.planFeatures.scheduling", value: true },
  { text: "subscription.planFeatures.detailedAnalytics", value: true },
  { text: "subscription.planFeatures.publicProfile", value: true },
  { text: "subscription.planFeatures.chat", value: true }  // Keep as "chat" in backend code
];

export const PREMIUM_FEATURES: PlanFeature[] = [
  { text: "subscription.planFeatures.unlimitedStudents", value: true },
  { text: "subscription.planFeatures.allProFeatures", value: true },
  { text: "subscription.planFeatures.aiFeatures", value: true },
  { text: "subscription.planFeatures.aiWorkouts", value: true },
  { text: "subscription.planFeatures.aiNutrition", value: true },
  { text: "subscription.planFeatures.createProductsPayments", value: true, comingSoon: true }
];

export const TEAMS_FEATURES: PlanFeature[] = [
  { text: "subscription.planFeatures.unlimitedStudents", value: true },
  { text: "subscription.planFeatures.allPremiumFeatures", value: true },
  { text: "subscription.planFeatures.teamManagement", value: true },
  { text: "subscription.planFeatures.multiUser", value: true },
  { text: "subscription.planFeatures.nutritionistModule", value: true, comingSoon: true }
];

export interface ButtonConfig {
  text: string;
  variant: "default" | "outline" | "secondary";
}
